import { useQuery } from '@tanstack/react-query';
import { api, unwrap } from './client';

/** Stammdaten, die in vielen Formularen gebraucht werden (klein, selten geändert → lange cachen). */
export const useAssetTypes = (includeInactive = false) =>
  useQuery({
    queryKey: ['asset-types', { includeInactive }],
    queryFn: () => unwrap(api.GET('/api/asset-types', { params: { query: { include_inactive: includeInactive ? 'true' : undefined } } })),
    select: (r) => r.data,
    staleTime: 5 * 60_000,
  });

export const useEmployeeOptions = (includeInactive = false) =>
  useQuery({
    queryKey: ['employees', 'options', { includeInactive }],
    queryFn: () => unwrap(api.GET('/api/employees', { params: { query: { page_size: 200, active: includeInactive ? undefined : 'true' } } })),
    select: (r) => r.data,
    staleTime: 60_000,
  });

export const useLocationOptions = (includeInactive = false) =>
  useQuery({
    queryKey: ['locations', 'options', { includeInactive }],
    queryFn: () => unwrap(api.GET('/api/locations', { params: { query: { page_size: 200, active: includeInactive ? undefined : 'true' } } })),
    select: (r) => r.data,
    staleTime: 60_000,
  });
